import type {
  CheckoutRequest,
  CheckoutResponse,
  PaymentConfirmRequest,
  HelcimTransactionResponse,
  PaymentHistoryResponse,
} from './types';

import { baseAPI } from '../base-api';

const endpoints = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    createCheckoutSession: builder.mutation<CheckoutResponse, CheckoutRequest>({
      query: (payload) => ({
        url: 'payment/checkout',
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
    }),

    getPaymentHistory: builder.query<PaymentHistoryResponse, number>({
      query: (invoiceId) => ({
        url: `payment/${invoiceId}`,
        method: 'GET',
      }),
      providesTags: (result, error, invoiceId) => [
        { type: 'Invoices', id: invoiceId },
      ],
    }),

    syncQuickbooksPayment: builder.mutation<PaymentHistoryResponse, number>({
      query: (invoiceId) => ({
        url: `payment/send-to-qb/${invoiceId}`,
        method: 'GET',
      }),
      invalidatesTags: (result, error, invoiceId) => [
        { type: 'Invoices', id: invoiceId },
      ],
    }),

    confirmPayment: builder.mutation<
      HelcimTransactionResponse,
      PaymentConfirmRequest
    >({
      query: (payload) => ({
        url: 'payment/confirm',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: (result, error, arg) => [
        'Jobs',
        'Work-Requests',
        { type: 'Invoices', id: arg.invoiceId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateCheckoutSessionMutation,
  useConfirmPaymentMutation,
  useGetPaymentHistoryQuery,
  useSyncQuickbooksPaymentMutation,
} = endpoints;

export { endpoints as PaymentService };
